import { Middleware } from "@reduxjs/toolkit";
import { loginAction, logOutAction } from "redux/authSlice";
import { resetContractSearchSession } from "screens/ContractSearch/ContractSearchHelper";

/**
 * A contract-search conversation belongs to one sign-in. Every way out (explicit, idle, 401, SSO,
 * password expiry) and every way in dispatches these two actions, so clearing here covers them all:
 * the next user, or the same user after logging in again, always starts a fresh conversation.
 */
export const contractSearchMiddleware: Middleware = () => (next) => (action: any) => {
  const result = next(action);
  if (action?.type === logOutAction.type || action?.type === loginAction.type) {
    resetContractSearchSession();
  }
  return result;
};
